import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-ai-statistics-skeleton',
  templateUrl: './ai-statistics-skeleton.component.html',
  styleUrls: ['./ai-statistics-skeleton.component.css'],
  imports: [SkeletonComponent],
})
export class AiStatisticsSkeletonComponent {
  readonly kpiRows = [1, 2, 3];
  readonly kpiCols = [1, 2, 3, 4];
  readonly tableRows = [1, 2, 3, 4, 5, 6, 7, 8];
  readonly tableCols = [1, 2, 3, 4, 5];
}
